module.exports = __webpack_public_path__ + "static/media/icon1.03e58376.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icon1.jpeg
// module id = 196
// module chunks = 0